import { defineNuxtPlugin } from '#app/nuxt'
import { LazyWAccordion, LazyWAccordionItem, LazyWAppLayout, LazyWBadge, LazyWBadgeStatus, LazyWBreadcrumbs, LazyWBreadcrumbsItem, LazyWButton, LazyWCasinoCard, LazyWCasinoCardGrid, LazyWCasinoCardLane, LazyWCasinoCardSkeleton, LazyWCasinoHeadNav, LazyWCasinoWinners, LazyWCheckbox, LazyWCheckboxGroup, LazyWCombobox, LazyWCurtainItem, LazyWCurtainLane, LazyWDataTable, LazyWDivider, LazyWDropdownBase, LazyWFlexLayout, LazyWFooter, LazyWFooterImage, LazyWFooterLinks, LazyWIcon, LazyWImage, LazyWInputCustom, LazyWInputSearch, LazyWInputSearchHeader, LazyWInputWrapper, LazyWLabel, LazyWLaneScroller, LazyWLink, LazyWLottie, LazyWMarkdown, LazyWMessageProvider, LazyWModalProvider, LazyWModalTemplate, LazyWNavigationBar, LazyWPopover, LazyWProgressLine, LazyWProviderCard, LazyWProviderCardGrid, LazyWProviderCardLane, LazyWRadio, LazyWRadioGroup, LazyWSectionHeader, LazyWSectionHeaderCounterButton, LazyWSectionHeaderLaneControls, LazyWSegmentedControls, LazyWSelect, LazyWSelectOption, LazyWSkeleton, LazyWSpinner, LazyWStepper, LazyWStepperBadge, LazyWSwitch, LazyWTab, LazyWTable, LazyWTableCell, LazyWTableCellExpandContent, LazyWTableRow, LazyWTableTree, LazyWTabs, LazyWTag, LazyWToggleButton, LazyWWidget, LazyWWidgetPanel, LazyWWidgetToolbar } from '#components'
const lazyGlobalComponents = [
  ["WAccordion", LazyWAccordion],
["WAccordionItem", LazyWAccordionItem],
["WAppLayout", LazyWAppLayout],
["WBadge", LazyWBadge],
["WBadgeStatus", LazyWBadgeStatus],
["WBreadcrumbs", LazyWBreadcrumbs],
["WBreadcrumbsItem", LazyWBreadcrumbsItem],
["WButton", LazyWButton],
["WCasinoCard", LazyWCasinoCard],
["WCasinoCardGrid", LazyWCasinoCardGrid],
["WCasinoCardLane", LazyWCasinoCardLane],
["WCasinoCardSkeleton", LazyWCasinoCardSkeleton],
["WCasinoHeadNav", LazyWCasinoHeadNav],
["WCasinoWinners", LazyWCasinoWinners],
["WCheckbox", LazyWCheckbox],
["WCheckboxGroup", LazyWCheckboxGroup],
["WCombobox", LazyWCombobox],
["WCurtainItem", LazyWCurtainItem],
["WCurtainLane", LazyWCurtainLane],
["WDataTable", LazyWDataTable],
["WDivider", LazyWDivider],
["WDropdownBase", LazyWDropdownBase],
["WFlexLayout", LazyWFlexLayout],
["WFooter", LazyWFooter],
["WFooterImage", LazyWFooterImage],
["WFooterLinks", LazyWFooterLinks],
["WIcon", LazyWIcon],
["WImage", LazyWImage],
["WInputCustom", LazyWInputCustom],
["WInputSearch", LazyWInputSearch],
["WInputSearchHeader", LazyWInputSearchHeader],
["WInputWrapper", LazyWInputWrapper],
["WLabel", LazyWLabel],
["WLaneScroller", LazyWLaneScroller],
["WLink", LazyWLink],
["WLottie", LazyWLottie],
["WMarkdown", LazyWMarkdown],
["WMessageProvider", LazyWMessageProvider],
["WModalProvider", LazyWModalProvider],
["WModalTemplate", LazyWModalTemplate],
["WNavigationBar", LazyWNavigationBar],
["WPopover", LazyWPopover],
["WProgressLine", LazyWProgressLine],
["WProviderCard", LazyWProviderCard],
["WProviderCardGrid", LazyWProviderCardGrid],
["WProviderCardLane", LazyWProviderCardLane],
["WRadio", LazyWRadio],
["WRadioGroup", LazyWRadioGroup],
["WSectionHeader", LazyWSectionHeader],
["WSectionHeaderCounterButton", LazyWSectionHeaderCounterButton],
["WSectionHeaderLaneControls", LazyWSectionHeaderLaneControls],
["WSegmentedControls", LazyWSegmentedControls],
["WSelect", LazyWSelect],
["WSelectOption", LazyWSelectOption],
["WSkeleton", LazyWSkeleton],
["WSpinner", LazyWSpinner],
["WStepper", LazyWStepper],
["WStepperBadge", LazyWStepperBadge],
["WSwitch", LazyWSwitch],
["WTab", LazyWTab],
["WTable", LazyWTable],
["WTableCell", LazyWTableCell],
["WTableCellExpandContent", LazyWTableCellExpandContent],
["WTableRow", LazyWTableRow],
["WTableTree", LazyWTableTree],
["WTabs", LazyWTabs],
["WTag", LazyWTag],
["WToggleButton", LazyWToggleButton],
["WWidget", LazyWWidget],
["WWidgetPanel", LazyWWidgetPanel],
["WWidgetToolbar", LazyWWidgetToolbar],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
